var _style, _g, _g2, _path, _path2, _path3, _polygon, _path4, _path5, _rect, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackcurrants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#509D34;}\n\t.st2{fill:#006633;}\n\t.st3{fill:#4A4A49;}\n\t.st4{fill:#B17F4A;}\n\t.st5{fill:none;stroke:#7D4E24;stroke-width:1.417;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#7D4E24;stroke-width:1.0393;stroke-miterlimit:10;}\n\t.st7{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.43,182.46c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.13,148.16,63.74,182.46,106.43,182.46"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.65,95.09c0,0,4.14,0.51,7.99-0.49c3.85-1,6.41-3.06,6.41-3.06l-2.18-0.5l3.03-4.51l-4.05,0.29 c0,0,2.75-2.42,3.57-3.41c0.83-0.99,0.83-0.99,0.83-0.99s-3.56-1.2-4.78-1.15c0,0,0.55-3.98,0.82-5.97s0.27-1.99,0.27-1.99 l-2.9,1.66c0,0,1.3-2.86,1.5-5.17c0.2-2.32,0.2-2.32,0.2-2.32l-3.74,1.59c0,0,0.21-2.53-0.49-4.28c-0.7-1.76-1.43-3.09-1.43-3.09 l-1.99,2.27c0,0-2.17-3.74-2.38-4.44l-0.91,1.94l-2.12-5.06c0,0-0.97,1.4-2.28,3.09s-2.21,4.79-2.21,4.79l-0.72-2.71l-2.45,6.36 l-2.1-2.72l-2.08,7.03l-5.25-5.53l-1.12,1.92c0,0-4.02-3.84-7.62-5.1c-3.6-1.26-4.88-1.16-4.88-1.16l0.06,4.25 c0,0-3.26-3.4-5.23-4.58c-1.97-1.17-1.97-1.17-1.97-1.17l0.2,3.25l-4.97-2.65l3.02,5.66l-10.07-4.99l-0.14,1.68l-10.81-1.23 L56,67.96l-3.42,0.35l6.62,6.92l-3.11,0.48c0,0,2.95,3.96,5.04,5.52s2.09,1.56,2.09,1.56l-4.3,0.7c0,0,2.93,4.17,5.71,5.15 c2.78,0.98,4.58,1.02,4.58,1.02l-3.79,2.22l9.88,4.76l0.32,2.47l6.59,2.25l-5.41,6.33l3.39,1.24l-3.05,4.72l2.53,1.38l-3.12,5.57 l5.42-1.45l-0.04,2.96l9.2-2.29l0.81,4.2l5.14-3.17l0.61,2.81l6.29-6.67l2.14,3.47l4.26-6.53l2.05,3.35c0,0,4.81-4.26,6.26-8.8 c1.45-4.54-0.83-8.97-1.38-9.97C116.78,97.49,114.65,95.09,114.65,95.09z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.89,93.42c-6.11-4.6-12.27-9.78-19.01-13.42c-6.49-3.51-13.9-6.27-21.24-7c2.38,0.58,4.61,1.67,6.81,2.71 c7.01,3.31,13.79,6.94,19.99,11.64c2.55,1.93,5.01,3.97,7.44,6.04c1.74,1.49,3.48,2.98,5.2,4.49L108.89,93.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.61,92.1c-11.71,5.16-17.02,18.83-11.86,30.54c5.16,11.71,18.83,17.02,30.54,11.86 c11.71-5.16,17.02-18.83,11.86-30.54C101,92.25,87.32,86.94,75.61,92.1z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 91.09,
    cy: 107.7,
    rx: 9.1,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "73.84,128.91 71.66,138.11 77.52,140.47 83,133.02  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3444 -0.9388 0.9388 0.3444 -70.9492 159.8167)",
    className: "st4",
    cx: 78.96,
    cy: 130.71,
    rx: 2.37,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 73.78,
    y1: 137.86,
    x2: 77.32,
    y2: 129.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 75.9,
    y1: 139.18,
    x2: 80.16,
    y2: 131.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.51,113.44c11.34,5.92,25.34,1.53,31.26-9.81c5.92-11.34,1.53-25.34-9.81-31.26c-11.34-5.92-25.34-1.53-31.26,9.81 C97.78,93.52,102.17,107.52,113.51,113.44z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9864 -0.1644 0.1644 0.9864 -12.1676 21.7081)",
    className: "st3",
    cx: 125.06,
    cy: 84.36,
    rx: 9.1,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "143.37,91.83 151.91,87.79 150.09,81.74 140.85,82.12  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9483 -0.3174 0.3174 0.9483 -20.2023 49.4168)",
    className: "st4",
    cx: 141.58,
    cy: 86.72,
    rx: 2.37,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 150.39,
    y1: 86.29,
    x2: 141.52,
    y2: 88.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 150.09,
    y1: 83.81,
    x2: 141.1,
    y2: 85.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.6,131.64c-0.75,12.77,8.99,23.74,21.76,24.49c12.77,0.75,23.74-8.99,24.49-21.76c0.75-12.77-8.99-23.74-21.76-24.49 C116.31,109.12,105.35,118.87,104.6,131.64z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8323 -0.5543 0.5543 0.8323 -46.2879 95.2771)",
    className: "st3",
    cx: 134.32,
    cy: 124.14,
    rx: 9.77,
    ry: 9.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "137.5,151.44 143.98,154.57 148.08,150.75 145.33,145.17  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7348 -0.6782 0.6782 0.7348 -62.6832 135.0922)",
    className: "st4",
    cx: 141.43,
    cy: 147.71,
    rx: 7.1,
    ry: 2.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 145.62,
    y1: 151.96,
    x2: 140.96,
    y2: 147.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 146.72,
    y1: 150.72,
    x2: 142.98,
    y2: 145.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 143.98,
    y1: 153.05,
    x2: 139.58,
    y2: 149.47
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.35,92.73c0-0.04-0.01-0.08-0.01-0.11C115.35,92.66,115.35,92.7,115.35,92.73L115.35,92.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.12,91.16L115.12,91.16c0.02,0.08,0.03,0.17,0.04,0.25C115.15,91.33,115.14,91.25,115.12,91.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.55,89.14c-0.02-0.07-0.05-0.13-0.07-0.2C114.5,89.01,114.53,89.07,114.55,89.14L114.55,89.14z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.62,101.26 113.62,101.26 113.62,101.27 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.33,95.81c0,0.02,0,0.04-0.01,0.07C115.32,95.85,115.32,95.83,115.33,95.81z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.23,103.39L112.23,103.39c-0.26,0.33-0.53,0.66-0.83,0.98C111.69,104.05,111.96,103.72,112.23,103.39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 102.42,
    transform: "matrix(0.9996 -0.029 0.029 0.9996 -2.9222 3.3176)",
    className: "st7",
    width: 0,
    height: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.08,97.34c-0.01,0.02-0.01,0.04-0.02,0.07C115.07,97.38,115.07,97.36,115.08,97.34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.42,94.27c0,0.01,0,0.02,0,0.03C115.42,94.29,115.42,94.28,115.42,94.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackcurrants);
export default __webpack_public_path__ + "static/media/Blackcurrants.5148db81d0d31266a95e826b1a0f2e50.svg";
export { ForwardRef as ReactComponent };